export class ReportFilterModel {
  startDateTime: string;
  endDateTime: string;
  instanceHashId: string = '';
  companyHashId: string = '';
  sVGHashId: string = '';
  vehicleHashId: string = '';
  organizationHashId: string = '';
  customerHashId: string = '';
  companyMasterHashId: string = '';
  sharedVehicleGroupHashId: string = '';
  contractTypeGroupHashId: string = '';
  groupByType: string = 'VEHICLE';
}

export class DropdownModel {
  keyHash: string;
  value: string;
  data: any;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/report-filter.model.ts